import { useContext, useEffect, useMemo, useState } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { useReviewsByPack } from 'app/hooks/data/core/extranet/review/useReviews';

export const usePacksSelection = () => {
  const { hotelId } = useContext(HotelContext);
  const { publishedPacks } = useContext(ModernHotelContext);

  const { data: reviewsByPack, isLoading: isReviewByPackLoading } =
    useReviewsByPack(hotelId);

  const [packIdsValue, setPackIdsValue] = useState<number[]>([]);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!isReviewByPackLoading && !!reviewsByPack && !initialized) {
      const packIds = reviewsByPack.packs.map((pack) => pack.id);

      setPackIdsValue(
        packIds.length ? packIds : publishedPacks?.map((pack) => pack.id) ?? []
      );
      setInitialized(true);
    }
  }, [isReviewByPackLoading, reviewsByPack, publishedPacks, initialized]);

  const packsFilter = useMemo(
    () =>
      packIdsValue.map((packId) => ({
        packId,
        isLegacy:
          reviewsByPack?.packs.find((pack) => pack.id === packId)?.isLegacy ??
          false,
      })),
    [packIdsValue, reviewsByPack?.packs]
  );

  return {
    packIdsValue,
    setPackIdsValue,
    packsFilter,
    reviewsByPack,
    isReviewByPackLoading,
  };
};
